import { Component, StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import './index.css';
import App from './App.jsx';
import { ThemeProvider } from './context/ThemeContext';

/* ── ErrorBoundary — prevents any uncaught JS exception from showing a blank
   page to users and to Google's renderer. Renders a minimal fallback instead. ── */
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <main style={{ padding: '2rem', fontFamily: 'sans-serif', color: '#fff', background: '#050b18', minHeight: '100vh' }}>
          <h1>Sanjivani DevWorks</h1>
          <p>React &amp; 3D Web Development Studio, Ahmedabad</p>
          <p>Something went wrong loading the experience. Please refresh the page or <a href="mailto:sanjivanidevworks@gmail.com" style={{ color: '#38BDF8' }}>contact us</a>.</p>
        </main>
      );
    }
    return this.props.children;
  }
}

/* ── Set initial data-theme before React mounts — prevents FOUC ── */
try {
  const saved = localStorage.getItem('sdw-theme') || 'dark';
  document.documentElement.setAttribute('data-theme', saved);
} catch {
  document.documentElement.setAttribute('data-theme', 'dark');
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <App />
        <Analytics />
        <SpeedInsights />
      </ThemeProvider>
    </ErrorBoundary>
  </StrictMode>,
);
